/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_CancelInputs */

const en_shared_cancel = /** @type {(inputs: Shared_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_shared_cancel = /** @type {(inputs: Shared_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const es_shared_cancel = /** @type {(inputs: Shared_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_shared_cancel = /** @type {(inputs: Shared_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/** @type {(inputs: Shared_CancelInputs) => LocalizedString} */
const it_shared_cancel = en_shared_cancel;

/** @type {(inputs: Shared_CancelInputs) => LocalizedString} */
const pt_br2_shared_cancel = en_shared_cancel;

/** @type {(inputs: Shared_CancelInputs) => LocalizedString} */
const pl_shared_cancel = en_shared_cancel;

/** @type {(inputs: Shared_CancelInputs) => LocalizedString} */
const hu_shared_cancel = en_shared_cancel;

/** @type {(inputs: Shared_CancelInputs) => LocalizedString} */
const ro_shared_cancel = en_shared_cancel;

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Shared_CancelInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_cancel = /** @type {((inputs?: Shared_CancelInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_CancelInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_cancel(inputs)
	if (locale === "de") return de_shared_cancel(inputs)
	if (locale === "es") return es_shared_cancel(inputs)
	if (locale === "fr") return fr_shared_cancel(inputs)
	if (locale === "it") return it_shared_cancel(inputs)
	if (locale === "pt-BR") return pt_br2_shared_cancel(inputs)
	if (locale === "pl") return pl_shared_cancel(inputs)
	if (locale === "hu") return hu_shared_cancel(inputs)
	return ro_shared_cancel(inputs)
});
export { shared_cancel as "shared.cancel" }